module.exports = __webpack_public_path__ + "static/media/afd.131629db.png";